export default "__VITE_ASSET__DSBiaDhh__"